export default "__VITE_ASSET__62882201__"